import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { useMemo } from "react";

// Same document the manifest review dialog's Vendor autocomplete reads.
const MANIFEST_REVIEW_VENDOR_NAMES = gql(`
  query ManifestReviewVendorNames {
    wasteManifestVendors
  }
`);

/** The registry's vendor names, as picker options. A bill's vendor is chosen from these, not typed. */
export function useWasteVendorOptions() {
  const { data, loading } = useQuery(MANIFEST_REVIEW_VENDOR_NAMES);
  const options = useMemo(
    () =>
      (data?.wasteManifestVendors ?? [])
        .map((name) => name.trim())
        .filter((name) => name.length > 0)
        .map((name) => ({ value: name, label: name })),
    [data?.wasteManifestVendors]
  );
  return { options, loading };
}
